const mergeAndSortVariantsWithProducts = (
  variantIdOrder,
  variants,
  products
) => {
  return variants.edges
    .sort(function (a, b) {
      return (
        variantIdOrder.indexOf(a.node.ID) - variantIdOrder.indexOf(b.node.ID)
      )
    })
    .map((variant) => {
      let p =
        products.edges.find(
          ({ node }) => node.ID === variant.node.hierarchy.product.id
        )?.node || null
      return { node: { ...variant.node, parentProduct: p } }
    })
}

export { mergeAndSortVariantsWithProducts }
